import React from 'react'

const Info = () => {
    return (
        <div className="about__info grid">
            <div className="about__box">
                <i className='bx bx-server about__icon' ></i>
                <h3 className="about__title">
                    Desarrollo web
                </h3>
            </div>

            <div className="about__box">
                <i className='bx bx-cloud about__icon'></i>
                <h3 className="about__title">
                    Desarrollo mobile
                </h3>
            </div>

            <div className="about__box">
                <i className='bx bx-infinite about__icon'></i>
                <h3 className="about__title">
                    Integración de sistemas web
                </h3>
            </div>
        </div>
    )
}

export default Info
